export class CaseReasonModel {
    reasonId: number;
    name:string;
    caseReasonType:string;
    etr:number;
    etrUnit:string
    status:string;
    tatConsideration:string;
    bucketType: string
    isCustomerAllowed:boolean = false;
    isCommunicationAllowed:boolean = false;
    is_circuit_update_table:boolean = false;
    sendToServer:boolean = false;
    isDelete:boolean=false
    constructor(){
        this.name="";
        this.status=null;
        this.tatConsideration=null;
        this.caseReasonType = null;
    }
}
